import type { IHorizontalMenuItem } from '@cover/types';

const LS_MENUS_STATE_KEY = 'isMenuCollapsedIntoCover';
const MIN_HEADER_MENU_ITEMS = 1;

export const useCoverStore = defineStore('cover', () => {
  const isMenuCollapsedIntoCover = ref(false);
  const isMenuStateChecked = ref(false);
  const headerMenus = ref<Array<string>>([]);
  const horizontalMenuItems = ref<Array<IHorizontalMenuItem>>([]);

  const initMenuState = () => {
    if (import.meta.client) {
      const lsIsMenuMovedToHeader = localStorage.getItem(LS_MENUS_STATE_KEY);

      if (lsIsMenuMovedToHeader) {
        isMenuCollapsedIntoCover.value = JSON.parse(lsIsMenuMovedToHeader);
      }

      isMenuStateChecked.value = true;
    }
  };

  const toggleMenu = () => {
    isMenuCollapsedIntoCover.value = !isMenuCollapsedIntoCover.value;

    if (import.meta.client) {
      localStorage.setItem(LS_MENUS_STATE_KEY, JSON.stringify(isMenuCollapsedIntoCover.value));
    }

    if (!isMenuCollapsedIntoCover.value) {
      headerMenus.value.splice(MIN_HEADER_MENU_ITEMS);
    }
  };

  const addHeaderMenuItem = (item: string, index: number) => {
    headerMenus.value[index] = item;
  };

  const setHorizontalMenuItems = (items: Array<IHorizontalMenuItem>) => {
    horizontalMenuItems.value = items;
  };

  return {
    isMenuCollapsedIntoCover,
    isMenuStateChecked,
    headerMenus,
    horizontalMenuItems,
    initMenuState,
    toggleMenu,
    addHeaderMenuItem,
    setHorizontalMenuItems,
  };
});
